/**
 * The small grey detail after a receipt's "Youngster Fee" line.
 *
 * The receipt keeps the fee's amount (`youngsterFee`) and its total
 * (`youngsterFeeTotal`) but not how it was charged. The backend
 * (`calculateYoungsterFees`) multiplies a per-day fee by the trip days and
 * charges a one-time fee once, so on a trip longer than a day a total equal
 * to the amount means a one-time fee. Before this, a one-time fee read
 * "(30 days @ 15/day)" next to a $15 total.
 */
export function youngsterFeeDetail(receipt: {
  totalDays?: number | null;
  youngsterFee?: number | null;
  youngsterFeeTotal?: number | null;
}): string {
  const days = Number(receipt.totalDays ?? 0);
  const fee = Number(receipt.youngsterFee ?? 0);
  const total = Number(receipt.youngsterFeeTotal ?? 0);
  if (days > 1 && fee > 0 && Math.abs(total - fee) < 0.005) {
    return '(one time)';
  }
  return `(${days} ${days === 1 ? 'day' : 'days'} @ ${fee}/day)`;
}
